import { render, staticRenderFns } from "./orderFrame.vue?vue&type=template&id=028d50d0&"
import script from "./orderFrame.vue?vue&type=script&lang=ts&"
export * from "./orderFrame.vue?vue&type=script&lang=ts&"
import style0 from "./orderFrame.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports